import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/TemplateCard.css';

function TemplateCard({ template }) {
  const formatPrice = (cents) => {
    const dollars = cents / 100;
    if (dollars < 10) return `$${dollars.toFixed(2)}`;
    return `$${Math.round(dollars)}`;
  };

  const formatTurnaround = (hours) => {
    if (!hours) return null;
    if (hours < 24) return `${hours}h`;
    const days = Math.round(hours / 24);
    return `${days}d`;
  };

  return (
    <Link to={`/jobs/${template.slug}`} className="template-card">
      <h3 className="template-card-title">{template.name}</h3>
      
      <p className="template-card-description">
        {template.description?.slice(0, 120)}
        {template.description?.length > 120 ? '...' : ''}
      </p>
      
      <div className="template-card-meta">
        <span className="category-badge">{template.category}</span>
        {template.turnaround_hours && (
          <span className="meta-item" title="Turnaround time">
            ⏱️ {formatTurnaround(template.turnaround_hours)}
          </span>
        )}
      </div>
      
      <div className="template-card-footer">
        <span className="template-price">{formatPrice(template.price_cents)}</span>
        <span className="template-cta">View Details →</span>
      </div>
    </Link>
  );
}

export default TemplateCard;
